export default __webpack_public_path__ + "static/media/facebook.0c283b8d.svg";